import React, { useEffect, useState, useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchInspDetailData } from "../../redux/slice/InspectionSlice/InspectionSlice";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/AxiosInstance";
import CompanyModal from "./CompanyModal";
import HistoryModal from "./HistoryModal";
import { BreadcrumbsContext } from "../../context/BcrumbsContextProvider";
import CustomGrid from "../../components/common/CustomGrid/CustomGrid";
import Loader from "../Loader/Loader";
import moment from "moment";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import { WqcForm } from "../Prints/WQC_form";
import { ClForm } from "../Prints/CL_form";
import { FfcForm } from "../Prints/FFC_form";
import { EbrForm } from "../Prints/EBR_form";
import { PtForm } from "../Prints/PT_form";
import { IcForm } from "../Prints/IC_form";
import { VcForm } from "../Prints/VC_form";
import { WscForm } from "../Prints/WSC_form";
import { IoMdArrowBack } from "react-icons/io";
import ExcelJS from "exceljs";
async function getBase64ImageFromUrl(url) {
  const response = await fetch(url);
  const blob = await response.blob();

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      // remove the "data:image/png;base64," prefix
      const base64 = reader.result.split(",")[1];
      resolve(base64);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

function InspectionView() {
  const dispatch = useDispatch();
  const { InspectionDetail, status } = useSelector(
    (state) => state?.Inspections
  );

  const { setBreadcrumbsItems } = useContext(BreadcrumbsContext);
  const [subHistory, setSubHistory] = useState([]);
  const navigate = useNavigate();
  const [insData, setInsData] = useState({});
  // console.log("insData", insData?.stagesdata[0]?.latestSubmission?.data);
  const [filterData, setFilterData] = useState([]);
  const location = useLocation();
  const data = location.state?.data;
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const [filteredEquipment, setFilteredEquipment] = useState([]);
  function HandleHistory(data) {
    setSubHistory(data);
    setShowModal2(true);
  }
  const handleBreadcrumbs = () => {
    setBreadcrumbsItems([
      {
        id: 1,
        url: "/package/pending",
        name: "Packages",
      },
      {
        id: 2,
        url: "/package/package-view",
        name: "PackageView",
      },
    ]);
  };

  useEffect(() => {
    handleBreadcrumbs();
    return () => {
      setBreadcrumbsItems([]);
    };
  }, [setBreadcrumbsItems]);
  useEffect(() => {
    dispatch(fetchInspDetailData(data));
  }, [dispatch]);
  useEffect(() => {
    let arr = [];
    if (InspectionDetail) {
      setInsData(InspectionDetail?.data);
      InspectionDetail?.data?.stagesdata?.forEach((item, idx) => {
        return arr.push({
          idx: idx + 1,
          username1:
            item?.reviewers
              ?.map((reviewer) => reviewer.reviewerId?.username)
              .join(", ") || "N/A",
          username2:
            item?.submissionAccess
              ?.map((reviewer) => reviewer.submitById?.username)
              .join(", ") || "N/A",
          title: item?.formId?.title || "N/A",
          updateAt: item?.updatedAt
            ? moment(item.updatedAt).format("DD MMM YYYY")
            : "N/A",
          ...item,
        });
      });
    }
    setFilterData(arr);
  }, [InspectionDetail]);
  const handleView = async (subdata, formid) => {
    const fetchSubmission = async () => {
      try {
        const submissionResponse = await axiosInstance.get(
          `Forms/${formid}/Submission/${subdata}`
        );
        if (submissionResponse) {

          navigate("/package/package-view/form", {
            state: {
              data: {
                form: formid,
                id: subdata,
              },
              submission: submissionResponse.data,
            },
          });
        }
      } catch (error) {
        console.error("Error fetching submission:", error);
      }
    };

    if (data) {
      fetchSubmission();
    } else {
      navigate("/my-package/form", {
        state: {
          data: data,
        },
      });
    }
  };
  const columns = [
    // {
    //     Header: "Sr",
    //     accessor: "idx", // Accessor is the "key" in the data
    //     width: "20px",
    // },
    {
      Header: "Stage #",
      accessor: "stageLevel",
      width: "20px",
    },

    {
      Header: "Submitters",
      accessor: "username2",
      width: "40px",
    },
    {
      Header: "Reviewers",
      accessor: "username1",
      width: "40px",
    },
    {
      Header: "Form Title",
      accessor: "title",
      width: "40px",
    },
    {
      Header: "Updated On",
      accessor: "updateAt",
      width: "40px",
      Cell: ({ value }) => {
        if (!value) return "";
        const date = new Date(value);
        return date.toLocaleDateString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
      },
    },
    {
      Header: "Submission",
      accessor: "latest",
      width: "20px",

      disableSortBy: true,
      Cell: (cell) => (
        <>
          {cell?.row?.original?.latestSubmission &&
            cell?.row?.original?.latestSubmission !== null ? (
            <button
              className="btn btn-outline-secondary mx-2 "
              onClick={() => {
                handleView(
                  cell?.row?.original?.latestSubmission?.id,
                  cell?.row?.original?.formId?._id
                );
              }}
            >
              View
            </button>
          ) : (
            <span style={{ paddingLeft: "10px" }}>N/A</span>
          )}
        </>
      ),
    },
    {
      Header: "Approval Status",
      accessor: "reviewStatus",
      width: "20px",
      Cell: (cell) => (
        <span
          style={{
            padding: "0.25rem 0.75rem",
            fontSize: "0.875rem",
            fontWeight: "600",
            color: "white",
            backgroundColor:
              cell.value === "Completed" || cell.value === "Approved"
                ? "green"
                : cell.value === "Rejected"
                  ? "red"
                  : cell.value === "Pending"
                    ? "orange"
                    : "rgb(79, 195, 247)",
            borderRadius: "9999px",
          }}
        >
          {cell.value}
        </span>
      ),
    },

    {
      Header: " History",
      accessor: "history",
      width: "20px",

      disableSortBy: true,
      Cell: (cell) => (
        <>
          {cell?.row?.original?.submissionHistory &&
            cell.row.original.submissionHistory.length > 0 ? (
            <button
              className="btn btn-outline-secondary mx-2 "
              onClick={() => {
                // HandleHistory(cell?.row?.original?.submissionHistory);
                HandleHistory(cell?.row?.original);
              }}
            >
              View
            </button>
          ) : (
            <span style={{ paddingLeft: "10px" }}>N/A</span>
          )}
        </>
      ),
    },
  ];
  useEffect(() => {
    setFilteredEquipment(InspectionDetail?.data?.equipmentNumbers || []);
  }, [InspectionDetail]);
  const columns2 = [
    {
      Header: "Serial #",
      accessor: "serialNumber",
      minWidth: 100,
      width: 120,
    },
    {
      Header: "Unit #",
      accessor: "unitNumber",
      minWidth: 100,
      width: 120,
    },
    {
      Header: "Equipment #",
      accessor: "equipmentNumber",
      minWidth: 120,
      width: 140,
    },
    {
      Header: "Description",
      accessor: "description",
    },
    {
      Header: "EQUIP TYPE",
      accessor: "equipType",
      minWidth: 100,
      width: 120,
    },
    {
      Header: "P&ID",
      accessor: "pAndId",
      minWidth: 120,
    },
    {
      Header: "National BD. #",
      accessor: "nationalBdNumber",
      minWidth: 150,
    },
    {
      Header: "Insulated",
      accessor: "insulated",
      minWidth: 100,
      width: 120,
    },
    {
      Header: "Design Pressure",
      accessor: "designPressure",
      minWidth: 150,
    },
    {
      Header: "Design Temp.",
      accessor: "designTemp",
      minWidth: 150,
    },
    {
      Header: "OPER. Pressure",
      accessor: "operPressure",
      minWidth: 150,
    },
    {
      Header: "OPER. Temp.",
      accessor: "operTemp",
      minWidth: 120,
    },
    {
      Header: "Year Built",
      accessor: "yearBuilt",
      minWidth: 100,
    },
    {
      Header: "WBS Code",
      accessor: "wbsCode",
      minWidth: 100,
    },
    {
      Header: "WSP #",
      accessor: "wspNumber",
      minWidth: 100,
    },
    {
      Header: "PWHT",
      accessor: "pwht",
      minWidth: 100,
    },
  ];
  const getFormComponent = (formName) => {
    switch (formName) {
      case "Cleanliness_Form":
        return ClForm;
      case "Fin_FanClosure_Form":
        return FfcForm;
      case "WQCF":
        return WqcForm;
      case "Bndl_Rls":
        return EbrForm;
      case "Hydro_Ts":
        return PtForm;
      case "Hydro_Ss":
        return PtForm;
      case "Internal_Closure_Form":
        return IcForm;
      case "Vessel_Closure_Form":
        return VcForm;
      case "WSCF":
        return WscForm;
      default:
        console.warn(`No component found for form: ${formName}`);
        return null;
    }
  };

  const generatePdfBlob = async (
    FormComponent,
    formData,
    text,
    reviewersData
  ) => {
    try {

      const result = reviewersData?.reduce((acc, review) => {
        if (review.status === "Approved") {
          // Check if status is "Approved"
          const roleName = review?.role?.roleName
            .toLowerCase()
            .replace(/\s+/g, "");

          acc[
            roleName == "executive/jobsupervisor"
              ? "executivejobsupervisor"
              : roleName
          ] = {
            username: review?.reviewerId?.username,
            statusUpdatedAt: review?.statusUpdatedAt,
            signature: review?.reviewerId?.signature, // Assuming "signature" is equivalent to comments
          };
        }
        return acc;
      }, {});
      return await pdf(
        <FormComponent data={formData} rolesData={result} text={text} />
      ).toBlob();
    } catch (error) {
      console.error("Error generating PDF blob:", error);
      return null;
    }
  };

  const addFormToZip = async (zip, form, formData, reviewersData) => {
    const formName = form.formId?.name;
    const fileName = `${form?.formId?.title}.pdf`;

    let text;
    if (formName === "Hydro_Ts") {
      text = "TS";
    } else if (formName === "Hydro_Ss") {
      text = "SS";
    }

    if (formData) {
      const pdfBlob = await generatePdfBlob(
        getFormComponent(formName),
        formData,
        text ? text : undefined,
        reviewersData
      );
      if (pdfBlob) {
        zip.file(fileName, pdfBlob);
      }
    } else {
      console.error(`Form ${formName} is missing submission data`);
    }
  };
  async function buildSheetFromForm(sheet, formObj, data) {
    const formLayouts = {
      "VCDC-ND": {
        title: "Vessel Calculation Data Collection",
        sections: {
          General: {
            "Eq/Cric": "equipmentNumber",
            Unit: "unitNumber",
            "National Board": "regNumber",
            "Serial Number": "serialNumber",
            Service: "description",
            Facility: "facility",
          },
          Code: {
            "Div 1 or Div 2": "division",
            "Code Year": "yearBuilt",
            "Vertical or Horizontal": "orient",
          },
          Shell: {
            Material: "refMaterial",
            "Fine Grain": "fineGrain",
            PWHT: "pwht",
            Efficiency: "jointEfficiency",
            "Length (in)": "lengthIn",
            "Nominal Thickness (in)": "orgThickness",
            "Min Measured Thickness (in)": "minMeasuredThicknessIn",
          },
          "Shell Course": {
            "Vessel ID (in)": "vesselIdIn",
            "Internal Pressure (PSI)": "internalPressurePsi",
            "Internal Temp (F)": "internalTempF",
            "External Pressure (PSI)": "externalPressurePsi",
            "External Temp (F)": "externalTempF",
            MDMT: "mdmtPerNameplateOrU1A",
            Hydro: "hydroPressureTempDate",
          },
          // "Lower Shell": {
          //   "Vessel ID (in)": "vesselIdIn1",
          //   "Internal Pressure (PSI)": "internalPressurePsi1",
          //   "Internal Temp (F)": "internalTempF1",
          //   "External Pressure (PSI)": "externalPressurePsi1",
          //   "External Temp (F)": "externalTempF1",
          //   MDMT: "mdmtPerNameplateOrU1A1",
          //   Hydro: "hydroPressureTempDate1",
          // },
          MISC: {
            "PSV Set Pressure (PSI)": "setPressure",
            "Max Liquid Fill Height (in)": "eqHeight",
            "Liquid Specific Gravity": "liquidSpecificGravity",
          },
          "Top Head": {
            "Hemi/Torr/Flat": "hemi21TorrFlat",
            Material: "refMaterial1",
            "Fine Grain": "fineGrain1",
            Efficiency: "efficiencyOrRtMark1",
            "Nominal Thickness (in)": "nominalThicknessIn1",
            "Min Measured Thickness (in)": "minMeasuredThicknessIn1",
          },
          "Bottom Head": {
            "Hemi/Torr/Flat": "hemi21TorrFlat1",
            Material: "refMaterial2",
            "Fine Grain": "fineGrain2",
            Efficiency: "efficiencyOrRtMark2",
            "Nominal Thickness (in)": "nominalThicknessIn2",
            "Min Measured Thickness (in)": "minMeasuredThicknessIn2",
          },
          Comment: {
            Comment: "textArea",

          },
        },
      },
      "NDC": {
        title: "Nozzle Data Collection",
        sections: {
          General: {
            "Eq/Cric": "equipmentNumber",
            Unit: "unitNumber",
            "National Board": "regNumber",
            "Serial Number": "serialNumber",
            Service: "description",
            Facility: "facility",
          },
          Nozzle: {
            "Nozzle #": "compId",
            Location: "location",
            "Flange Rating": "flangeRating",
            "Nozzle Size": "diameter",
            "Nozzle Thickness": "orgThickness",
            "Base Plate Thickness": "baseMetalThick",
            "Repad Thickness (a)": "repadThick",
            "Repad Width (b)": "repadWidth",
            "Fillet Weld Size (c)": "repadFilletWeldSize",
            "Fillet Weld Size (d)": "nozFilletWeldSize",
            "Distance from nozzle center line  to nearest seam":
              "distanceFromNozzleCenterLineToNearestSeam",
            "Reference Material": "refMaterial"
          },
          Comment: {
            Comment: "comment",
          }
        },
      },
      "VCDCC": {
        title: "Vessel Calculation Data Collection Components",
        sections: {
          General: {
            "Eq/Cric": "equipmentNumber",
            Unit: "unitNumber",
            "National Board": "regNumber",
            "Serial Number": "serialNumber",
            Service: "description",
            Facility: "facility",
          },
          Component: {
            "Component Description": "componentDescription",
            "Component Type": "componentType",
            Material: "refMaterial",
            "Fine Grain": "fineGrain",
            "PWHT (Y or N)": "pwht",
            "Efficiency (or RT mark)": "efficiencyOrRtMark",
            "Length (in)": "lengthIn",
            "Centerline distance from seam (Specify which)":
              "centerlineDistance",
            "Nominal Thickness (in)": "nominalThicknessIn",
            "Min Measured Thickness (in)": "minMeasuredThicknessIn",
          },
          Comment: {
            Comment: "comment",
          }
        },
      },
      "SSDC": {
        title: "Saddle Support Data Collection",
        sections: {
          General: {
            "Eq/Cric": "equipmentNumber",
            Unit: "unitNumber",
            "National Board": "regNumber",
            "Serial Number": "serialNumber",
            Service: "description",
            Facility: "facility",
          },
          Design: {
            "Number of saddles": "numberOfSaddles",
            Material: "refMaterial",
            "Allowable Tensile Stress": "allowableTensileStress",
            "Allowable Yield Stress": "allowableYieldStress",
            "Right Saddle Distance from": "rightSaddleDistanceFrom",
            " Datum (L)": "datumL",
            "Saddle Width (b)": "saddleWidthB",
            "Saddle Height (H)": "saddleHeightH",
            "Saddle Contact Angle (theta)": "saddleContactAngleTheta",
          },
          "Wear Plate": {
            "Has Wear Plate": "hasWearPlate",
            "Wear Plate Thickness (tp)": "wearPlateThicknessTp",
            "Wear Plate Width (Wp)": "wearPlateWidthWp",
            "Wear Plate Contact Angle": "wearPlateContactAngle",
            "Hort to Wear Plate (h)": "hortToWearPlateH",
          },
          Web: {
            "Web (Center or Edge)": "webCenterOrEdge",
            "Web Thickness (ts)": "webThicknessTs",
            "Base Plate Length ( E )": "basePlateLengthE",
            "Base Plate Width (F)": "basePlateLengthE1",
            "Base Plate Thickness (tb) ": "basePlateThicknessTb",
            "Base Plate Extends (X)": "basePlateExtendsX",
          },
          Ribs: {
            "Number or Ribs*": "ribThicknessIn",
            "Rib Spacing (in)": "ribSpacingIn",
            "Rib Thickness (in)": "ribThicknessIn",
          },
          MISC: {
            "Height of Saddle base above ground (in)":
              "heightOfSaddleBaseAboveGroundIn",
          },
          Comment: {
            Comment: "comment",
          }
        },
      },
      "IMAGEFORM": {
        title: "Image Form",
        sections: {
          Image: {
            "Equipment Number": "Iamge",
          },

        }
      }

    };

    const formType = formObj?.formId?.title;
    const layout = formLayouts[formType];
    console.log("this is layout", layout);
    // if (!layout) return;

    // Sheet setup
    sheet.columns = [{ width: 40 }, { width: 25 }];

    sheet.mergeCells("A1:B1");
    const titleCell = sheet.getCell("A1");
    titleCell.value = layout.title;
    titleCell.font = { size: 16, bold: true };
    titleCell.alignment = { horizontal: "center" };

    let rowIndex = 3;
    let colorIndex = 0;
    const sectionColors = [
      "FFFDE9D9",
      "FFE2EFDA",
      "FFD9E1F2",
      "FFFCE4D6",
      "FFF2F2F2",
      "FFE2EFDA",

    ];

    // pick latestSubmission.data if exists
    // const formData = formObj?.latestSubmission?.data || data || {};
    const formDataRaw = formObj?.latestSubmission?.data || data || {};
    const { submission, ...formData } = formDataRaw;
    console.log("formData for Excel:", submission);
    // Render sections
    for (const [sectionName, keyMap] of Object.entries(layout.sections)) {
      const bgColor = sectionColors[colorIndex % sectionColors.length];
      colorIndex++;

      if (formType === "NDC" && sectionName === "Nozzle") {
        // multiple nozzles
        const nozzleArray = formData.nozzle1 || [];
        nozzleArray.forEach((nozzle, nozzleIndex) => {
          sheet.mergeCells(`A${rowIndex}:B${rowIndex}`);
          const subHeader = sheet.getCell(`A${rowIndex}`);
          subHeader.value = `Nozzle ${nozzleIndex + 1}`;
          subHeader.font = { bold: true, size: 12 };
          subHeader.alignment = { horizontal: "center" };
          subHeader.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: bgColor },
          };
          rowIndex++;

          Object.entries(keyMap).forEach(([label, key]) => {
            const labelCell = sheet.getCell(`A${rowIndex}`);
            const valueCell = sheet.getCell(`B${rowIndex}`);
            labelCell.value = label;
            labelCell.font = { bold: true };
            labelCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
            valueCell.value = nozzle[key] ?? "";
            valueCell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
            valueCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
            rowIndex++;
          });

          rowIndex += 2;
        });
      } else if (formType === "VCDCC" && sectionName === "Component") {
        const compArray = formData.dataGrid || [];
        compArray.forEach((comp, compIndex) => {
          sheet.mergeCells(`A${rowIndex}:B${rowIndex}`);
          const subHeader = sheet.getCell(`A${rowIndex}`);
          subHeader.value = `Component ${compIndex + 1}`;
          subHeader.font = { bold: true, size: 12 };
          subHeader.alignment = { horizontal: "center" };
          subHeader.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: bgColor },
          };
          rowIndex++;

          Object.entries(keyMap).forEach(([label, key]) => {
            const labelCell = sheet.getCell(`A${rowIndex}`);
            const valueCell = sheet.getCell(`B${rowIndex}`);
            labelCell.value = label;
            labelCell.font = { bold: true };
            labelCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
            valueCell.value = comp[key] ?? "";
            valueCell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
            valueCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
            rowIndex++;
          });

          rowIndex += 2;
        });
      } else if (formType === "VCDC-ND" && (sectionName === "Shell" || sectionName === "Shell Course")) {
        if (sectionName === "Shell") {
          const shellKeys = layout.sections["Shell"] || {};
          const courseKeys = layout.sections["Shell Course"] || {};
          const gridArray = formData.dataGrid || [];

          gridArray.forEach((item, index) => {
            // ===============================
            // SHELL HEADER
            // ===============================
            sheet.mergeCells(`A${rowIndex}:B${rowIndex}`);
            const shellHeader = sheet.getCell(`A${rowIndex}`);
            shellHeader.value = `Shell ${index + 1}`;
            shellHeader.font = { bold: true, size: 12 };
            shellHeader.alignment = { horizontal: "center" };
            shellHeader.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: bgColor }
            };
            rowIndex++;

            // ===============================
            // SHELL FIELDS
            // ===============================
            Object.entries(shellKeys).forEach(([label, key]) => {
              const labelCell = sheet.getCell(`A${rowIndex}`);
              const valueCell = sheet.getCell(`B${rowIndex}`);

              labelCell.value = label;
              labelCell.font = { bold: true };
              labelCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: bgColor }
              };

              valueCell.value = item[key] ?? "";
              valueCell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" }
              };
              valueCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: bgColor }
              };

              rowIndex++;
            });

            rowIndex++;

            // ===============================
            // SHELL COURSE HEADER
            // ===============================
            sheet.mergeCells(`A${rowIndex}:B${rowIndex}`);
            const courseHeader = sheet.getCell(`A${rowIndex}`);
            courseHeader.value = `Shell Course ${index + 1}`;
            courseHeader.font = { bold: true, size: 12 };
            courseHeader.alignment = { horizontal: "center" };
            courseHeader.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: bgColor }
            };
            rowIndex++;

            // ===============================
            // SHELL COURSE FIELDS
            // ===============================
            Object.entries(courseKeys).forEach(([label, key]) => {
              const labelCell = sheet.getCell(`A${rowIndex}`);
              const valueCell = sheet.getCell(`B${rowIndex}`);

              labelCell.value = label;
              labelCell.font = { bold: true };
              labelCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: bgColor }
              };

              valueCell.value = item[key] ?? "";
              valueCell.border = {
                top: { style: "thin" },
                left: { style: "thin" },
                bottom: { style: "thin" },
                right: { style: "thin" }
              };
              valueCell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: bgColor }
              };

              rowIndex++;
            });

            rowIndex += 2;
          });
        }
        if (sectionName === "Shell Course") {
          continue;
        }
      } else if (formType === "IMAGEFORM") {
        const grid = formData.dataGrid || [];
        if (grid.length === 0) return;

        // Section Header

        // rowIndex += 2;

        for (const [index, item] of grid.entries()) {
          const imageObj = item.image?.[0];
          const description = item.description || "";

          if (!imageObj || !imageObj.url) return;

          //  INDEX NUMBER
          sheet.mergeCells(`A${rowIndex}:D${rowIndex}`);
          const indexCell = sheet.getCell(`A${rowIndex}`);
          indexCell.value = `${index + 1}.`;
          indexCell.font = { bold: true, size: 13 };
          indexCell.alignment = { horizontal: "center", vertical: "middle" };
          indexCell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: {
              argb: "FFB2E4BE"
            }
          };
          indexCell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" }
          };
          rowIndex += 2;

          //  LABEL: IMAGE
          const labelImageCell = sheet.getCell(`A${rowIndex}`);
          labelImageCell.value = "Image:";
          labelImageCell.font = { bold: true };
          labelImageCell.alignment = { vertical: "top" };

          const base64Data = await getBase64ImageFromUrl(imageObj.url);

          // EMBED IMAGE in ExcelJS
          const imageId = sheet.workbook.addImage({
            base64: base64Data,
            extension: imageObj.type?.split("/")?.[1] || "png",
          });


          const imgStartRow = rowIndex;
          const imgEndRow = imgStartRow + 10;  // bigger image height
          sheet.mergeCells(`B${imgStartRow}:C${imgEndRow}`);

          sheet.addImage(imageId, {
            tl: { col: 1, row: imgStartRow - 1 },   // column B
            br: { col: 3, row: imgEndRow - 1 },     // column C
            editAs: "oneCell",
          });

          rowIndex = imgEndRow + 1;

          // 🔹 LABEL: DESCRIPTION
          const labelDescCell = sheet.getCell(`A${rowIndex}`);
          labelDescCell.value = "Description:";
          labelDescCell.font = { bold: true };

          // DESCRIPTION VALUE (right side)
          sheet.mergeCells(`B${rowIndex}:C${rowIndex + 1}`);
          const descCell = sheet.getCell(`B${rowIndex}`);
          descCell.value = description;
          descCell.alignment = { wrapText: true, vertical: "top" };

          rowIndex += 3; // spacing between entries
        }

        return;
      } else {
        // Normal section
        sheet.mergeCells(`A${rowIndex}:B${rowIndex}`);
        const sectionCell = sheet.getCell(`A${rowIndex}`);
        sectionCell.value = sectionName;
        sectionCell.font = { bold: true, size: 13 };
        sectionCell.alignment = { horizontal: "center" };
        sectionCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
        rowIndex++;

        Object.entries(keyMap).forEach(([label, key]) => {
          const labelCell = sheet.getCell(`A${rowIndex}`);
          const valueCell = sheet.getCell(`B${rowIndex}`);
          labelCell.value = label;
          labelCell.font = { bold: true };
          labelCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
          valueCell.value = formData[key] ?? "";
          valueCell.border = { top: { style: "thin" }, left: { style: "thin" }, bottom: { style: "thin" }, right: { style: "thin" } };
          valueCell.fill = { type: "pattern", pattern: "solid", fgColor: { argb: bgColor } };
          rowIndex++;
        });

        rowIndex += 2;
      }
    }
  }

  const handleDownloadZip = async () => {
    if (!insData) return;

    const zip = new JSZip();

    // Folder name: number_title
    const pkgFolderName = `${insData.inspectionNumber || "NO_NUM"}(${insData.title?.replace(/\s+/g, "_")})`;
    const pkgFolder = zip.folder(pkgFolderName);

    for (const stage of insData?.stagesdata || []) {
      const formType = stage?.formId?.title || `Stage_${stage.stageLevel}`;
      const submissionData = stage?.latestSubmission?.data || {};
      const reviewersData = stage?.reviewers || [];

      // file base: StageLevel_FormTitle
      const fileBase = `Stage-${stage.stageLevel}_${formType}`.replace(/\s+/g, "_");

      if (["VCDC-ND", "NDC", "VCDCC", "SSDC", "IMAGEFORM"].includes(formType)) {
        // Excel Export
        const workbook = new ExcelJS.Workbook();
        const sheet = workbook.addWorksheet(formType.substring(0, 30));
        await buildSheetFromForm(sheet, stage, submissionData);
        const buffer = await workbook.xlsx.writeBuffer();

        pkgFolder.file(`${fileBase}.xlsx`, buffer);

      } else {
        // PDF Export
        await addFormToZip(pkgFolder, stage, submissionData, reviewersData, fileBase);
      }
    }

    try {
      const zipFile = await zip.generateAsync({ type: "blob" });
      saveAs(zipFile, `${insData.inspectionNumber || "Package"}_${insData.title || ""}.zip`);
    } catch (error) {
      console.error("Error generating ZIP file:", error);
    }
  };



  // const handleDownloadZip = async () => {
  //   const zip = new JSZip();
  //   const forms = insData?.stagesdata || [];

  //   for (const item of forms) {
  //     await addFormToZip(
  //       zip,
  //       item,
  //       item?.latestSubmission?.data || {},
  //       item?.reviewers || null
  //     );
  //   }

  //   try {
  //     const zipFile = await zip.generateAsync({ type: "blob" });
  //     saveAs(zipFile, `${insData?.inspectionNumber}.zip`);
  //   } catch (error) {
  //     console.error("Error generating ZIP file:", error);
  //   }
  // };

  // async function exportToCSV(jsonData, fileName = "form.xlsx") {
  //   const dataArray = Array.isArray(jsonData) ? jsonData : [jsonData];
  //   if (dataArray.length === 0) {
  //     alert("No data to export!");
  //     return;
  //   }

  //   const workbook = new ExcelJS.Workbook();

  //   // Define section layouts for each form type
  //   const formLayouts = {
  //     "VCDC-ND": {
  //       title: "Vessel Calculation Data Collection",
  //       sections: {
  //         "General": {
  //           "Eq/Cric": "equipmentNumber",
  //           "Unit": "unitNumber",
  //           "National Board": "regNumber",
  //           "Serial Number": "serialNumber",
  //           "Service": "description",
  //           "Facility": "facility"
  //         },
  //         "Code": {
  //           "Div 1 or Div 2": "division",
  //           "Code Year": "yearBuilt",
  //           "Vertical or Horizontal": "orient"
  //         },
  //         "Shell": {
  //           "Material": "shellMaterial",
  //           "Fine Grain": "fineGrain",
  //           "PWHT": "pwht",
  //           "Efficiency": "jointEfficiency",
  //           "Length (in)": "lengthIn",
  //           "Nominal Thickness (in)": "orgThickness",
  //           "Min Measured Thickness (in)": "minMeasuredThicknessIn"
  //         },
  //         "Upper Shell": {
  //           "Vessel ID (in)": "vesselIdIn",
  //           "Internal Pressure (PSI)": "internalPressurePsi",
  //           "Internal Temp (F)": "internalTempF",
  //           "External Pressure (PSI)": "externalPressurePsi",
  //           "External Temp (F)": "externalTempF",
  //           "MDMT": "mdmtPerNameplateOrU1A",
  //           "Hydro": "hydroPressureTempDate"
  //         },
  //         "Lower Shell": {
  //           "Vessel ID (in)": "vesselIdIn1",
  //           "Internal Pressure (PSI)": "internalPressurePsi1",
  //           "Internal Temp (F)": "internalTempF1",
  //           "External Pressure (PSI)": "externalPressurePsi1",
  //           "External Temp (F)": "externalTempF1",
  //           "MDMT": "mdmtPerNameplateOrU1A1",
  //           "Hydro": "hydroPressureTempDate1"
  //         },
  //         "MISC": {
  //           "PSV Set Pressure (PSI)": "setPressure",
  //           "Max Liquid Fill Height (in)": "eqHeight",
  //           "Liquid Specific Gravity": "liquidSpecificGravity"
  //         },
  //         "Top Head": {
  //           "Hemi/Torr/Flat": "hemi21TorrFlat",
  //           "Material": "material1",
  //           "Fine Grain": "fineGrain1",
  //           "Efficiency": "efficiencyOrRtMark1",
  //           "Nominal Thickness (in)": "nominalThicknessIn1",
  //           "Min Measured Thickness (in)": "minMeasuredThicknessIn1"
  //         },
  //         "Bottom Head": {
  //           "Hemi/Torr/Flat": "hemi21TorrFlat1",
  //           "Material": "material2",
  //           "Fine Grain": "fineGrain2",
  //           "Efficiency": "efficiencyOrRtMark2",
  //           "Nominal Thickness (in)": "nominalThicknessIn2",
  //           "Min Measured Thickness (in)": "minMeasuredThicknessIn2"
  //         }
  //       }
  //     },

  //     "NDC": {
  //       title: "Nozzle Data Collection",
  //       sections: {
  //         General: {
  //           "Eq/Cric": "equipmentNumber",
  //           "Unit": "unitNumber",
  //           "National Board": "regNumber",
  //           "Serial Number": "serialNumber",
  //           "Service": "description",
  //           "Facility": "facility"
  //         },
  //         "Nozzle": {
  //           "Nozzle #": "compId",
  //           "Location": "location",
  //           "Flange Rating": "flangeRating",
  //           "Nozzle Size": "diameter",
  //           "Nozzle Thickness": "orgThickness",
  //           "Base Plate Thickness": "baseMetalThick",
  //           "Repad Thickness (a)": "repadThick",
  //           "Repad Width (b)": "repadWidth",
  //           "Fillet Weld Size (c)": "repadFilletWeldSize",
  //           "Fillet Weld Size (d)": "nozFilletWeldSize",
  //           "Distance from nozzle center line  to nearest seam": "distanceFromNozzleCenterLineToNearestSeam"
  //         }
  //       }
  //     },
  //     "VCDCC": {
  //       title: "Vessel Calculation Data Collection Components",
  //       sections: {
  //         General: {
  //           "Eq/Cric": "equipmentNumber",
  //           "Unit": "unitNumber",
  //           "National Board": "regNumber",
  //           "Serial Number": "serialNumber",
  //           "Service": "description",
  //           "Facility": "facility"
  //         },
  //         "Component": {
  //           "Component Description": "componentDescription",
  //           "Component Type": "componentType",
  //           "Material": "material",
  //           "Fine Grain": "fineGrain",
  //           "PWHT (Y or N)": "pwht",
  //           "Efficiency (or RT mark)": "efficiencyOrRtMark",
  //           "Length (in)": "lengthIn",
  //           "Centerline distance from seam (Specify which)": "centerlineDistance",
  //           "Nominal Thickness (in)": "nominalThicknessIn",
  //           "Min Measured Thickness (in)": "minMeasuredThicknessIn"
  //         }
  //       }
  //     },
  //     "SSDC": {
  //       title: "Saddle Support Data Collection",
  //       sections: {
  //         "General": {
  //           "Eq/Cric": "equipmentNumber",
  //           "Unit": "unitNumber",
  //           "National Board": "regNumber",
  //           "Serial Number": "serialNumber",
  //           "Service": "description",
  //           "Facility": "facility"
  //         },
  //         "Design": {
  //           "Number of saddles": "numberOfSaddles",
  //           "Material": "material",
  //           "Allowable Tensile Stress": "allowableTensileStress",
  //           "Allowable Yield Stress": "allowableYieldStress",
  //           "Right Saddle Distance from": "rightSaddleDistanceFrom",
  //           " Datum (L)": "datumL",
  //           "Saddle Width (b)": "saddleWidthB",
  //           "Saddle Height (H)": "saddleHeightH",
  //           "Saddle Contact Angle (theta)": "saddleContactAngleTheta",

  //         },
  //         "Wear Plate": {
  //           "Has Wear Plate": "hasWearPlate",
  //           "Wear Plate Thickness (tp)": "wearPlateThicknessTp",
  //           "Wear Plate Width (Wp)": "wearPlateWidthWp",
  //           "Wear Plate Contact Angle": "wearPlateContactAngle",
  //           "Hort to Wear Plate (h)": "hortToWearPlateH"
  //         },
  //         "Web": {
  //           "Web (Center or Edge)": "webCenterOrEdge",
  //           "Web Thickness (ts)": "webThicknessTs",
  //           "Base Plate Length ( E )": "basePlateLengthE",
  //           "Base Plate Width (F)": "basePlateLengthE1",
  //           "Base Plate Thickness (tb) ": "basePlateThicknessTb",
  //           "Base Plate Extends (X)": "basePlateExtendsX"
  //         },

  //         "Ribs": {
  //           "Number or Ribs*": "ribThicknessIn",
  //           "Rib Spacing (in)": "ribSpacingIn",
  //           "Rib Thickness (in)": "ribThicknessIn"
  //         },

  //         "MISC": {
  //           "Height of Saddle base above ground (in)": "heightOfSaddleBaseAboveGroundIn",
  //         }
  //       }
  //     },
  //   };

  //   //sections colors
  //   const sectionColors = [
  //     "FFFDE9D9",
  //     "FFE2EFDA",
  //     "FFD9E1F2",
  //     "FFFCE4D6",
  //     "FFF2F2F2"
  //   ];

  //   // Loop over all forms and create a new sheet for each
  //   dataArray.forEach((formObj) => {
  //     const formType = formObj?.formId?.title;
  //     const layout = formLayouts[formType];
  //     if (!layout) return; // skip unknown forms

  //     // Create a sheet 
  //     const sheetName = (formType || "Form").substring(0, 31);
  //     const sheet = workbook.addWorksheet(sheetName);

  //     // Set column widths
  //     sheet.columns = [
  //       { width: 40 }, // keys
  //       { width: 25 }  // values
  //     ];

  //     // Title row
  //     sheet.mergeCells("A1:B1");
  //     const titleCell = sheet.getCell("A1");
  //     titleCell.value = layout.title;
  //     titleCell.font = { size: 16, bold: true };
  //     titleCell.alignment = { horizontal: "center" };

  //     let rowIndex = 3;
  //     let colorIndex = 0;
  //     const data = formObj.latestSubmission?.data || {};

  //     // Render sections
  //     Object.entries(layout.sections).forEach(([sectionName, keyMap]) => {
  //       const bgColor = sectionColors[colorIndex % sectionColors.length];
  //       colorIndex++;

  //       if (formType === "NDC" && sectionName === "Nozzle") {
  //         //  Special handling for nozzle array
  //         const nozzleArray = data.nozzle1 || [];

  //         nozzleArray.forEach((nozzle, nozzleIndex) => {
  //           // Sub-section header for each nozzle
  //           sheet.mergeCells(`A${rowIndex}:B${rowIndex}`);
  //           const nozzleHeader = sheet.getCell(`A${rowIndex}`);
  //           nozzleHeader.value = `Nozzle ${nozzleIndex + 1}`;
  //           nozzleHeader.font = { bold: true, size: 12 };
  //           nozzleHeader.alignment = { horizontal: "center" };
  //           nozzleHeader.fill = {
  //             type: "pattern",
  //             pattern: "solid",
  //             fgColor: { argb: bgColor }
  //           };
  //           rowIndex++;

  //           // Rows for each nozzle property
  //           Object.entries(keyMap).forEach(([label, key]) => {
  //             const labelCell = sheet.getCell(`A${rowIndex}`);
  //             const valueCell = sheet.getCell(`B${rowIndex}`);

  //             labelCell.value = label;
  //             labelCell.font = { bold: true };
  //             labelCell.fill = {
  //               type: "pattern",
  //               pattern: "solid",
  //               fgColor: { argb: bgColor }
  //             };

  //             valueCell.value = nozzle[key] ?? "";
  //             valueCell.border = {
  //               top: { style: "thin" },
  //               left: { style: "thin" },
  //               bottom: { style: "thin" },
  //               right: { style: "thin" }
  //             };
  //             valueCell.fill = {
  //               type: "pattern",
  //               pattern: "solid",
  //               fgColor: { argb: bgColor }
  //             };

  //             rowIndex++;
  //           });

  //           rowIndex += 2; // spacing after each nozzle
  //         });
  //       } else if (formType === "VCDCC" && sectionName === "Component") {
  //         //  Special handling for nozzle array
  //         const nozzleArray = data.dataGrid || [];

  //         nozzleArray.forEach((nozzle, nozzleIndex) => {
  //           // Sub-section header for each nozzle
  //           sheet.mergeCells(`A${rowIndex}:B${rowIndex}`);
  //           const nozzleHeader = sheet.getCell(`A${rowIndex}`);
  //           nozzleHeader.value = `Component ${nozzleIndex + 1}`;
  //           nozzleHeader.font = { bold: true, size: 12 };
  //           nozzleHeader.alignment = { horizontal: "center" };
  //           nozzleHeader.fill = {
  //             type: "pattern",
  //             pattern: "solid",
  //             fgColor: { argb: bgColor }
  //           };
  //           rowIndex++;

  //           // Rows for each nozzle property
  //           Object.entries(keyMap).forEach(([label, key]) => {
  //             const labelCell = sheet.getCell(`A${rowIndex}`);
  //             const valueCell = sheet.getCell(`B${rowIndex}`);

  //             labelCell.value = label;
  //             labelCell.font = { bold: true };
  //             labelCell.fill = {
  //               type: "pattern",
  //               pattern: "solid",
  //               fgColor: { argb: bgColor }
  //             };

  //             valueCell.value = nozzle[key] ?? "";
  //             valueCell.border = {
  //               top: { style: "thin" },
  //               left: { style: "thin" },
  //               bottom: { style: "thin" },
  //               right: { style: "thin" }
  //             };
  //             valueCell.fill = {
  //               type: "pattern",
  //               pattern: "solid",
  //               fgColor: { argb: bgColor }
  //             };

  //             rowIndex++;
  //           });

  //           rowIndex += 2;
  //         });
  //       } else {
  //         //  Normal section 
  //         sheet.mergeCells(`A${rowIndex}:B${rowIndex}`);
  //         const sectionCell = sheet.getCell(`A${rowIndex}`);
  //         sectionCell.value = sectionName;
  //         sectionCell.font = { bold: true, size: 13 };
  //         sectionCell.alignment = { horizontal: "center" };
  //         sectionCell.fill = {
  //           type: "pattern",
  //           pattern: "solid",
  //           fgColor: { argb: bgColor }
  //         };
  //         rowIndex++;

  //         Object.entries(keyMap).forEach(([label, key]) => {
  //           const labelCell = sheet.getCell(`A${rowIndex}`);
  //           const valueCell = sheet.getCell(`B${rowIndex}`);

  //           labelCell.value = label;
  //           labelCell.font = { bold: true };
  //           labelCell.fill = {
  //             type: "pattern",
  //             pattern: "solid",
  //             fgColor: { argb: bgColor }
  //           };

  //           valueCell.value = data[key] ?? "";
  //           valueCell.border = {
  //             top: { style: "thin" },
  //             left: { style: "thin" },
  //             bottom: { style: "thin" },
  //             right: { style: "thin" }
  //           };
  //           valueCell.fill = {
  //             type: "pattern",
  //             pattern: "solid",
  //             fgColor: { argb: bgColor }
  //           };

  //           rowIndex++;
  //         });

  //         rowIndex += 2; // spacing
  //       }
  //     });
  //   });

  //   // Download file
  //   const buffer = await workbook.xlsx.writeBuffer();
  //   const blob = new Blob([buffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  //   });
  //   const link = document.createElement("a");
  //   link.href = URL.createObjectURL(blob);
  //   link.download = fileName;
  //   link.click();
  // }



  return (
    <div className="h-[450px] overflow-y-auto overflow-x-hidden  scrollbar-custom ">
      <div className="w-full flex custom-layout " style={{ gap: "30px" }}>
        {/* Left column */}
        <div className="left-column ">
          <div className="d-flex ">
            <button
              onClick={() => navigate(-1)}
              style={{
                color: "black",
                cursor: "pointer",
                marginRight: "16px",
              }}
            >
              <IoMdArrowBack fontSize="24px" />
            </button>
            <p
              style={{ fontWeight: 700, fontSize: "larger" }}
            // className="dark-head"
            >
              {" "}
              Package Detail
            </p>
          </div>
          <div className="card dark-panel2">
            <ul
              className="list-group list-group-flush"
              style={{ marginLeft: "5px", marginRight: "10px" }}
            >
              <li className="list-group-item dark-panel2">
                <div className="viewtextd " style={{ gap: "113px" }}>
                  <p style={{ fontWeight: 600 }}>Package #</p>
                  <p>{insData?.inspectionNumber}</p>
                </div>
              </li>
              <li className="list-group-item dark-panel2">
                <div className="viewtextd " style={{ gap: "153px" }}>
                  <p style={{ fontWeight: 600 }}>Title</p>
                  <p>{insData?.title}</p>
                </div>
              </li>
              <li className=" list-group-item dark-panel2 ">
                <div className="viewtextd " style={{ gap: "70px" }}>
                  <p style={{ fontWeight: 600 }}>Company Name</p>
                  <p
                    onClick={() => setShowModal(true)}
                    style={{
                      borderRadius: "8888px",
                      padding: "0.15rem 0.75rem",
                      fontSize: "0.875rem",
                      fontWeight: "500",
                      textAlign: "center",
                      height: " 30px",
                      backgroundColor: "lightgrey",
                      color: "#242323de",
                      cursor: "pointer",
                    }}
                  >
                    {insData?.companyName}
                  </p>
                </div>
              </li>
              <li className="list-group-item dark-panel2">
                <div className="viewtextd " style={{ gap: "113px" }}>
                  <p style={{ fontWeight: 600 }}>Site Name</p>
                  <p>{insData?.jobSiteName}</p>
                </div>
              </li>
              <li className="list-group-item dark-panel2">
                <div className="viewtextd " style={{ gap: "75px" }}>
                  <p style={{ fontWeight: 600 }}>Package Status</p>
                  <p
                    style={{
                      color:
                        insData?.inspectionstatus === "Pending"
                          ? "orange"
                          : insData?.inspectionstatus === "InProgress"
                            ? "rgb(79, 195, 247)"
                            : insData?.inspectionstatus === "Approved" ||
                              insData?.inspectionstatus === "Completed"
                              ? "green"
                              : insData?.inspectionstatus === "Rejected"
                                ? "red"
                                : "inherit",
                      border:
                        insData?.inspectionstatus === "Pending"
                          ? "2px solid orange "
                          : insData?.inspectionstatus === "InProgress"
                            ? "2px solid rgb(79, 195, 247) "
                            : insData?.inspectionstatus === "Approved" ||
                              insData?.inspectionstatus === "Completed"
                              ? "2px solid green"
                              : insData?.inspectionstatus === "Rejected"
                                ? "2px solid red"
                                : "none",
                      borderRadius: "8888px",
                      padding: "0.15rem 0.75rem",
                      fontSize: "0.875rem",
                      fontWeight: "600",
                      width: "auto",
                      textAlign: "center",
                      height: " 32px",
                    }}
                  >
                    {insData?.inspectionstatus}
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Right column */}
        <div className="right-column ">
          <div>
            <p className="title">Stages</p>
            <div className="row">
              <div className="col-6 col-sm-4 mb-3 text-center ">
                <div className="card  stage-card dark-panel2">
                  <div className="card-body">
                    <p className="card-title font-weight-bold">Total Stages</p>
                    <p className="card-value text-primary font-weight-bold">
                      {insData?.totalStagesCount}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-5 col-sm-4 mb-3 text-center">
                <div className="card dark-panel2 stage-card">
                  <div className="card-body">
                    <p className="card-title font-weight-bold">
                      Pending Stages
                    </p>
                    <p className="card-value text-warning font-weight-bold">
                      {insData?.pendingStagesCount}
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-6 col-sm-4 mb-3 text-center">
                <div className="card dark-panel2 stage-card">
                  <div className="card-body">
                    <p className="card-title font-weight-bold">
                      Completed Stages
                    </p>
                    <p className="card-value text-success font-weight-bold">
                      {insData?.completedStagesCount}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style={{ marginRight: "20px" }} >
            <p style={{ fontWeight: 600 }}>Stages Status</p>
            <div className="card dark-panel2">
              <ul
                className="list-group list-group-flush "
                style={{ marginLeft: "5px", marginRight: "10px" }}
              >
                {insData && (
                  <>
                    <li className="list-group-item dark-panel2">
                      <div className="viewtext">
                        <div className="stage-header">
                          <p style={{ fontWeight: 700 }}>Current Stage</p>
                        </div>
                        <div className="stage-info">
                          <p style={{ fontWeight: 600 }}>Stage No.</p>
                          <p>{insData.currentStage?.stageNo || "N/A"}</p>
                        </div>
                        <div className="stage-status">
                          <p style={{ fontWeight: 600 }}>Status</p>
                          {insData.currentStage?.status ? (
                            <p
                              style={{
                                color:
                                  insData.currentStage?.status === "Pending"
                                    ? "orange"
                                    : insData.currentStage?.status ===
                                      "Approved" ||
                                      insData.currentStage?.status ===
                                      "Completed"
                                      ? "green"
                                      : insData.currentStage?.status ===
                                        "Rejected"
                                        ? "red"
                                        : "inherit",
                                border:
                                  insData.currentStage?.status === "Pending"
                                    ? "2px solid orange "
                                    : insData.currentStage?.status ===
                                      "Approved" ||
                                      insData.currentStage?.status ===
                                      "Completed"
                                      ? "2px solid green"
                                      : insData.currentStage?.status ===
                                        "Rejected"
                                        ? "2px solid red"
                                        : "none",
                                borderRadius: "9999px",
                                padding: "0.25rem 0.75rem",
                                fontSize: "0.875rem",
                                fontWeight: "600",
                                width: "95px",
                                textAlign: "center",
                              }}
                            >
                              {insData.currentStage?.status || "N/A"}
                            </p>
                          ) : (
                            <p>N/A</p>
                          )}
                        </div>
                      </div>
                    </li>

                    {insData.previousStage && (
                      <li className="list-group-item bg-light">
                        <div className="viewtext">
                          <div className="stage-header">
                            <p style={{ fontWeight: 700 }}>Previous Stage</p>
                          </div>
                          <div className="stage-info">
                            <p style={{ fontWeight: 600 }}>Stage No.</p>
                            <p>{insData.previousStage?.stageNo}</p>
                          </div>
                          <div className="stage-status">
                            <p style={{ fontWeight: 600 }}>Status</p>
                            <p
                              style={{
                                color:
                                  insData.previousStage?.status === "Pending"
                                    ? "orange"
                                    : insData.previousStage?.status ===
                                      "Approved" ||
                                      insData.previousStage?.status ===
                                      "Completed"
                                      ? "green"
                                      : insData.previousStage?.status ===
                                        "Rejected"
                                        ? "red"
                                        : "inherit",
                                border:
                                  insData.previousStage?.status === "Pending"
                                    ? "2px solid orange "
                                    : insData.previousStage?.status ===
                                      "Approved" ||
                                      insData.previousStage?.status ===
                                      "Completed"
                                      ? "2px solid green"
                                      : insData.previousStage?.status ===
                                        "Rejected"
                                        ? "2px solid red"
                                        : "none",
                                borderRadius: "9999px",
                                padding: "0.25rem 0.75rem",
                                fontSize: "0.875rem",
                                fontWeight: "600",
                                width: "95px",
                                textAlign: "center",
                              }}
                            >
                              {insData.previousStage?.status}
                            </p>
                          </div>
                        </div>
                      </li>
                    )}

                    {insData.nextStage && (
                      <li className="list-group-item bg-light">
                        <div className="viewtext">
                          <div className="stage-header">
                            <p style={{ fontWeight: 700 }}>Next Stage</p>
                          </div>
                          <div className="stage-info">
                            <p style={{ fontWeight: 600 }}>Stage No.</p>
                            <p>{insData.nextStage?.stageNo}</p>
                          </div>
                          <div className="stage-status">
                            <p style={{ fontWeight: 600 }}>Status</p>
                            <p
                              style={{
                                color:
                                  insData.nextStage?.status === "Pending"
                                    ? "orange"
                                    : insData.nextStage?.status ===
                                      "Approved" ||
                                      insData.nextStage?.status === "Completed"
                                      ? "green"
                                      : insData.nextStage?.status === "Rejected"
                                        ? "red"
                                        : "inherit",
                                border:
                                  insData.nextStage?.status === "Pending"
                                    ? "2px solid orange"
                                    : insData.nextStage?.status ===
                                      "Approved" ||
                                      insData.nextStage?.status === "Completed"
                                      ? "2px solid green"
                                      : insData.nextStage?.status === "Rejected"
                                        ? "2px solid red"
                                        : "none",
                                borderRadius: "9999px",
                                padding: "0.25rem 0.75rem",
                                fontSize: "0.875rem",
                                fontWeight: "600",
                                width: "95px",
                                textAlign: "center",
                              }}
                            >
                              {insData.nextStage?.status}
                            </p>
                          </div>
                        </div>
                      </li>
                    )}
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-end w-60 mr-12" style={{ marginRight: "10px" }}>
        {/* <button onClick={() => exportToCSV(insData?.stagesdata, `${insData?.title}(${insData?.inspectionNumber}).csv`)} className="btn btn-outline-primary m-2">
          Export to CSV
        </button> */}
        <button
          onClick={handleDownloadZip}
          className="btn btn-primary m-2"
        >
          Download ZIP
        </button>

      </div>

      <div>
        <p style={{ fontWeight: 600, marginTop: "5px" }}>
          Stages Detail
        </p>
        <CustomGrid columns={columns} data={filterData} />
      </div>
      {filteredEquipment?.length > 0 && (
        <div
          style={{
            paddingBottom: "35px",
          }}
        >
          <p
            style={{
              fontWeight: 600,
              marginTop: "5px",
            }}
          >
            Euipments Detail
          </p>
          <CustomGrid columns={columns2} data={filteredEquipment} />
        </div>
      )}
      {status === "loading" && (
        <div className="text-center">
          <Loader />
        </div>
      )}

      <CompanyModal
        open={showModal}
        onClose={() => setShowModal(false)}
        state={insData?.companyData}
      />
      <HistoryModal
        open={showModal2}
        onClose={() => setShowModal2(false)}
        state={subHistory}
      />
    </div>
  );
}
export default InspectionView;
